import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import VueBarcodeScanner from 'vue-barcode-scanner'
import * as Sentry from '@sentry/vue'

Vue.config.productionTip = false

// Define environment variables that will be replaced at build time
// This prevents "Cannot read properties of undefined (reading 'env')" errors in production
const ENV = {
  NODE_ENV: process.env.NODE_ENV || 'production',
  VUE_APP_SENTRY_DSN: process.env.VUE_APP_SENTRY_DSN || ''
};

// Make ENV available globally
Vue.prototype.$env = ENV;

// Initialize Sentry only if DSN is available
if (ENV.VUE_APP_SENTRY_DSN && ENV.VUE_APP_SENTRY_DSN.trim() !== '' && ENV.VUE_APP_SENTRY_DSN !== 'https://your-sentry-dsn-here@sentry.io/your-project-id') {
  console.log('Initializing Sentry with DSN:', ENV.VUE_APP_SENTRY_DSN);
  Sentry.init({
    Vue,
    dsn: ENV.VUE_APP_SENTRY_DSN,
    // Only track errors, not performance or components
    // Log errors to console in development
    logErrors: ENV.NODE_ENV === 'development',
  });
} else {
  console.log('Sentry initialization skipped: No valid DSN provided');
}

Vue.use(VueBarcodeScanner, {
  sensitivity: 100
})

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
